import { toPairs } from "lodash";

export default function getMyUpsolveEntryUrl(params) {
  const queryString = toPairs(params || {})
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  return queryString ? `${UPSOLVE_FILER_URL}/intro?${queryString}` : UPSOLVE_FILER_URL;
}
